import { GetFieldDefFromName } from "@/Utils/DataLib";

export const getDisplayMap = (
  data: Record<string, string>,
  objClassName: string,
  doKeyWordLookUp?: boolean
) => {
  const displayMap: Record<string, string> = {};
  Object.entries(data).forEach(([key, value]) => {
    let fieldDef = GetFieldDefFromName(value, objClassName, doKeyWordLookUp);
    displayMap[key] = fieldDef ? fieldDef.GetFieldName() : value;
  });
  return displayMap;
};
